<template>
	<div class="arrow-left-down">
		<svg
			width="22.627441"
			height="22.627441"
			viewBox="0 0 22.6274 22.6274"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_2296">
					<rect
						id="search"
						width="16.000000"
						height="16.000000"
						transform="translate(0.000000 11.313721) rotate(-45.000000)"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_2296)">
				<path
					id="path"
					d="M13.38 15.67C13.29 15.76 13.17 15.82 13.02 15.82L7.3 15.82C7.03 15.82 6.8 15.59 6.8 15.32L6.8 9.59C6.8 9.32 7.03 9.09 7.3 9.09C7.57 9.09 7.8 9.32 7.8 9.59L7.8 14.82L13.02 14.82C13.3 14.82 13.52 15.04 13.52 15.32C13.53 15.45 13.47 15.58 13.38 15.67Z"
					fill="#77797C"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M15.67 7.66L7.74 15.59C7.54 15.78 7.22 15.78 7.03 15.59C6.83 15.4 6.83 15.08 7.03 14.88L14.96 6.95C15.16 6.76 15.48 6.76 15.67 6.95C15.86 7.14 15.86 7.46 15.67 7.66Z"
					fill="#77797C"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconArrowLeftDown extends Vue {}
</script>

<style scoped lang="scss">
.arrow-left-down {
	display: flex;
}
</style>
